import p1before from "../../../images/products/p1before.jpeg";
import p1after from "../../../images/products/p1after.jpeg";
import p2after from "../../../images/products/p2after.jpeg";
import p3before from "../../../images/products/p3before.jpeg";
import p3after from "../../../images/products/p3after.jpeg";
import p4before from "../../../images/products/p4before.jpeg";
import p4after from "../../../images/products/p4after.jpeg";
import p5before from "../../../images/products/p5before.jpeg";
import p5after from "../../../images/products/p5after.jpeg";
// import p6before from "../../../images/products/p6before.jpeg";
import p6after from "../../../images/products/p6after.jpeg";
import p7before from "../../../images/products/p7before.jpeg";
import p8after from "../../../images/products/p8after.jpeg";
import p9before from "../../../images/products/p9before.jpeg";

export const services = [
  {
    id: 1,
    name: "Benz Ml350 2014 to 2019 GLE",
    imgBefore: p1before,
    imgAfter: p1after,
  },
  {
    id: 2,
    name: "Ml350 dashboard upgrade",
    imgBefore: null,
    imgAfter: p2after,
  },
  {
    id: 3,
    name: "Toyota Highlander 2008 upgraded to 2020 vip",
    imgBefore: p3before,
    imgAfter: p3after,
  },
  {
    id: 4,
    name: "Gwagon Upgrade 2015 to 2021",
    imgBefore: p4before,
    imgAfter: p4after,
  },
  {
    id: 5,
    name: "Toyota Hilux 2017 upgraded to 2023 Adventure",
    imgBefore: p5before,
    imgAfter: p5after,
  },
  {
    id: 6,
    name: "Upholstery of seats and dashboard",
    imgBefore: null,
    imgAfter: p6after,
  },
  {
    id: 7,
    name: "work in progress",
    imgBefore: p7before,
    imgAfter: null,
  },
  {
    id: 8,
    name: "landcruser 2010 upgraded to 2022 lc300",
    imgBefore: null,
    imgAfter: p8after,
  },
  {
    id: 9,
    name: "work in progress",
    imgBefore: p9before,
    imgAfter: null,
  },
];
